import React, { useCallback, useContext } from 'react';
import * as PropTypes from 'prop-types';

import nanoid from 'nanoid';
import Checkbox from 'ati-ui-react/components/Checkbox';
import withCarTypes from 'ati-ui-react/HOC/withCarTypes';
import { classes } from 'as-ui-kit/utils/styles';

import { LocaleContext } from 'contexts';
import styles from './styles.modules.scss';

const CarTypesList = ({options, selectedValues, onChange}) => {
    const locale = useContext(LocaleContext);
    const handleChange = useCallback((event) => {
        const { value } = event.target;
        if (onChange) {
            setTimeout(() => onChange(value), 0);
        }
    }, [onChange]);

    const itemRenderer = (item) => {
        let isParent = Object.entries(item.children).length !== 0;
        return (
            <li
                className={classes(styles['list-item'], item.isChild && styles['child'], isParent && styles['parent'])}
            >
                <Checkbox
                    checked={selectedValues.includes(item.id)}
                    className="checkbox"
                    label={locale === 'en' ? item.nameEng : item.name}
                    size="small"
                    value={item.id}
                    onChange={handleChange}
                />
            </li>
        );
    };

    const renderCarTypesList = (options) => options.map((item) => (
        <React.Fragment key={nanoid()}>
            {itemRenderer(item)}
        </React.Fragment>
    ));

    return (
        <ul
            className={styles['dropdown-list']}
            data-qa="car-types-list"
        >
            {renderCarTypesList(options)}
        </ul>
    );
};

export default withCarTypes(CarTypesList);

CarTypesList.propTypes = {
    options: PropTypes.array,
    selectedValues: PropTypes.array,
    onChange: PropTypes.func
};
